import React, { useEffect, useRef, useState } from "react";
import outlook_icon from "../../assets/Icons/outlook_icon.svg";
import "./Login.scss";
import {
  authService,
  getAnchoredResourceByUser,
  getUserInfo,
  saveUserDataInLocal,
  updateInfoCompanies,
} from "../../services/authService";
import { environment } from "../../environments/environment";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Snackbar } from "@mui/material";

import { useSnackBar } from "../../hooks/useSnackBar";
import { useDispatch } from "react-redux";
import { addTab } from "../../redux/features/TabsManager/tabSlice";
import { useMsal } from "@azure/msal-react";
import { renewToken } from "../../services/authConfig.jsx";

const Login = () => {
  const { loginOutlook, getUserToken } = authService();
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = environment.basePath;
  const isAuthenticated = localStorage.getItem("u_tk") !== null;
  const from = location.state?.from?.pathname + location.state?.from?.search || basePath + "/customdashboard";
  const dispatch = useDispatch();
  const { errorMsg } = useSnackBar();
  const { instance } = useMsal();
  const handleOutlookLogin = async () => {// funcion que se ejecuta en el login
    try {
      const responseLogin = await loginOutlook(instance);
      if (responseLogin == 200) {
        // await renewToken();
        setTimeout(async () => {
          await getInfoUser();
          const expirated_path = localStorage.getItem("path_pre_expiration");
          if (expirated_path) {
            localStorage.removeItem("path_pre_expiration");
            navigate(expirated_path);
          } else {
            navigate(from);
            //navigate(basePath + "/customdashboard");
          }
        }, 200);
      } else {
        errorMsg(
          "An error has ocurred",
          "An error occurred while trying to log in"
        );
      }
    } catch (error) {
      errorMsg(
        "Unexpected error",
        "An unexpected error occurred while trying to log in"
      );
    }
  };



  const getInfoUser = async () => {
    const request = await getUserInfo();

    if (request.data.responseCode == 200) {
      const companyInfo = request.data.load.companies.map((e) => {
        return {
          id: e.company.id,
          name: e.company.name,
          address: e.company.address,
          idRelation: e.id,
          isSelected: e.isSelected,
        };
      });
      let selectedCompany = companyInfo.find((e) => e.isSelected === true);
      if (!selectedCompany) {
        selectedCompany = companyInfo[0];
        selectedCompany.isSelected = true;
        updateInfoCompanies({
          id: selectedCompany.idRelation,
          user: {
            id: parseInt(request.data.load.id),
          },
          company: {
            id: selectedCompany.id,
          },
          isSelected: true,
        });
      }
      saveUserDataInLocal(
        request.data.load.username,
        request.data.load.email,
        request.data.load.id,
        selectedCompany.id,
        selectedCompany.name,
        companyInfo,
        request.data.load.account.id
      );
      return true;
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    // setErrorInLogin(false);
  };

  const validateActiveSession = () => {
    let idToken = getUserToken();
    if (idToken) {
      navigate(basePath + "/customDashboard");
    }
  };

  useEffect(() => {
    // validateActiveSession()
  }, []);

  useEffect(() => {
    if (localStorage.getItem('u_tk')) {
      renewToken().then(authResponse => {
        if (authResponse.isAuthenticated) {
          getInfoUser().then(r => 
          {
            if (r) {

              navigate(from, { replace: true });
            }
          }
          );
        }
      }
      );
    }
  }, []);

  let companyName = "Kodo";
  let terms_and_conditions =
    " Lorem ipsum dolor, sit amet consectetur adipisicingelit. Nostrum nobis, esse accusamus dolore repellendus hic non vitae doloribus id sint!";

  return (
    <>
      <main className="main-login-cont">
        <section className="login-form">
          <div className="top-form-login">
            <h1>{companyName}</h1>
            <h3>Welcome</h3>
            <button onClick={handleOutlookLogin}>
              <img src={outlook_icon} alt="" />
              Sign in with Outlook
            </button>
          </div>

          <div className="bottom-form-login">
            {/* <p className="login-terms">{terms_and_conditions}</p> */}
          </div>
        </section>
      </main>
    </>
  );
};

export default Login;
